import * as React from "react";
import Button from "@mui/material/Button";
import Popover from "@mui/material/Popover";
import PopupState, { bindTrigger, bindPopover } from "material-ui-popup-state";

import PrivacyTipIcon from "@mui/icons-material/PrivacyTip";

export default function PopoverPopupState({ text }) {
  return (
    <PopupState variant="popover" popupId="demo-popup-popover">
      {(popupState) => (
        <div>
          <Button className="w-fit" {...bindTrigger(popupState)}>
            <PrivacyTipIcon />
          </Button>
          <Popover
            {...bindPopover(popupState)}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "center",
            }}
          >
            <p className={`max-w-lg px-2  text-end`}>{text}</p>
          </Popover>
        </div>
      )}
    </PopupState>
  );
}
